import { createFileRoute } from "@tanstack/react-router";
import { CTABand } from "@/components/site/CTABand";
import { PhoneButton } from "@/components/site/PhoneButton";

export const Route = createFileRoute("/financing")({
  head: () => ({
    meta: [
      { title: "Plumbing Financing Phoenix | Affordable Payments" },
      { name: "description", content: "Need plumbing financing in Phoenix? Phoenix Plumbing Co. offers approved-credit financing on larger jobs. Call 602-834-1208." },
      { property: "og:title", content: "Plumbing Financing Phoenix | Affordable Payments" },
      { property: "og:description", content: "Need plumbing financing in Phoenix? Phoenix Plumbing Co. offers approved-credit financing on larger jobs. Call 602-834-1208." },
      { property: "og:url", content: "https://www.phoenixplumbing.co/financing" },
      { name: "twitter:title", content: "Plumbing Financing Phoenix | Affordable Payments" },
      { name: "twitter:description", content: "Need plumbing financing in Phoenix? Phoenix Plumbing Co. offers approved-credit financing on larger jobs. Call 602-834-1208." },
    ],
    links: [{ rel: "canonical", href: "https://www.phoenixplumbing.co/financing" }],
  }),
  component: Page,
});

function Page() {
  return (
    <>
      <section className="bg-secondary text-secondary-foreground">
        <div className="mx-auto max-w-4xl px-4 py-14">
          <h1 className="text-4xl md:text-5xl font-extrabold">Plumbing Financing Phoenix</h1>
          <p className="mt-4 text-secondary-foreground/85 text-lg">Need plumbing financing in Phoenix? Phoenix Plumbing Co. offers approved-credit financing on larger jobs. Call 602-834-1208.</p>
          <div className="mt-6"><PhoneButton size="lg" /></div>
        </div>
      </section>
      <article className="mx-auto max-w-3xl px-4 py-12 prose prose-lg">
        <p>We partner with leading home-improvement lenders to offer approved-credit financing on water heater replacements, repipes, sewer line work, and remodels. Same-day approvals, no prepayment penalties, and flexible terms.</p><h2>How to apply</h2><p>Call <a href="tel:+16028341208" className="text-primary font-bold">602-834-1208</a> and ask about financing — we'll send you a secure application link and have an answer in minutes.</p>
      </article>
      <CTABand />
    </>
  );
}
